import { diaDaSemanaCurto, formatarDataCurta } from "../../util/datas";
import { cx } from "./cx";

/** Urgência vem da API (a contagem de dias úteis é regra, não tela: constituição §5.1). */
export type Urgencia = "normal" | "perto" | "vencido";

const corFatal = (u: Urgencia) => (u === "normal" ? "text-texto-3" : "text-alerta");

/**
 * A dupla que só existe aqui (constituição §6.3): o dia de TRABALHAR e o dia que NÃO PODE passar, sempre
 * separados e nessa ordem. O fatal só ganha cor quando aperta.
 */
export function Prazo({ execucao, fatal, urgencia = "normal" }: { execucao?: string | null; fatal?: string | null; urgencia?: Urgencia }) {
  if (!execucao && !fatal) return <span className="text-meta text-texto-3">sem data</span>;
  return (
    <span className="inline-flex items-baseline gap-3">
      {execucao && <span className="font-medium text-texto-1" title="Execução (quando fazer)">{diaDaSemanaCurto(execucao)} <span className="numeros">{formatarDataCurta(execucao)}</span></span>}
      {fatal && <span className={cx("text-meta", corFatal(urgencia))} title="Prazo fatal">{urgencia === "vencido" ? "venceu" : "fatal"} <span className="numeros">{formatarDataCurta(fatal)}</span></span>}
    </span>
  );
}

/** Só o fatal, para listas agrupadas pelo dia de execução. */
export function PrazoFatal({ fatal, urgencia = "normal" }: { fatal?: string | null; urgencia?: Urgencia }) {
  if (!fatal) return <span className="text-meta text-texto-3">sem fatal</span>;
  return (
    <span className={cx("text-meta whitespace-nowrap", corFatal(urgencia), urgencia !== "normal" && "font-medium")} title="Prazo fatal">
      {urgencia === "vencido" ? "venceu" : "fatal"} <span className="numeros">{formatarDataCurta(fatal)}</span>
    </span>
  );
}
